/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useState, useEffect } from 'react';

import Avatar from '@uniiverse/library/components/avatar';

import locale from '../organization-select/locale';
import ChevronIcon from '../../assets/account-nav-bar/chevron.svg';
import { OrganizationContext } from './withOrganization';
import currentUserToMembership from '../../helpers/userToMembership';

import { getItem, setItem, removeItem } from '../../lib/session-storage';

import styles from './styles.css';

// Read the persisted MUM selection, tolerating a missing or malformed value.
function getStoredMumHostId() {
  const stored = getItem('mumHost');
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);
    return parsed && parsed.id ? parsed.id : null;
  } catch (error) {
    return null;
  }
}

const OrganizationSelect = (props) => {

  const { setSelectedMembership, selectedUser, setSelectedUser } = useContext(OrganizationContext);
  const [ expanded, setExpanded ] = useState(false);

  // `withOrganization` restores `selectedUser` from `mumHost` before first render,
  // but the full membership (permissions, event_ids) isn't persisted there -- it
  // only arrives with the `memberships` query. Until then `selectedMembership`
  // stays on the logged-in user, so account-scoped reads (hostId, permissions,
  // add-ons) resolve to the wrong account after a fresh page load. Once
  // memberships arrive, reconcile `selectedMembership` with the stored selection
  // (or clear a stale selection the member no longer has access to).
  useEffect(() => {
    const storedHostId = getStoredMumHostId();
    if (!storedHostId || props.memberships.length === 0) return;

    const match = props.memberships.find((membership) => membership.owner.id === storedHostId);
    if (match) {
      setSelectedMembership(match);
    }
    else {
      removeItem('mumHost');
      setSelectedMembership(currentUserToMembership(props.currentUser));
      setSelectedUser(props.currentUser);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.memberships]);

  const onOrganizationChange = (memberships) => {
    setSelectedMembership(memberships)
    setSelectedUser(memberships.owner)

    if (props.currentUser.id !== memberships.owner.id) {
      const mumHost = {
        id: memberships.owner.id,
        firstName: memberships.owner.first_name,
        lastName: memberships.owner.last_name,
        imageUrl: memberships.owner.image_url_50,
        currencies: memberships.owner.currencies
      };
      setItem('mumHost', JSON.stringify(mumHost));
    }
    else {
      removeItem('mumHost');
    }

    toggleShowOptions()
  }

  const toggleShowOptions = async () => setExpanded(!expanded);

  const selectedUserId = selectedUser.id

  if (props.memberships.length === 0) return <div/>

  return (
    <div className={`${styles.organizationSelectSelect} ${props.enabled ? '' : styles.organizationSelectDisabled}`}>
      <div className={styles.organizationSelectSelected}
      onClick={()=>{toggleShowOptions()}}>
        <Avatar
          user={selectedUser}
          size="small"/>
        <p className={styles.organizationSelectName}>{selectedUserId === props.currentUser.id ?
          props.intl.formatMessage(locale.myAccount) : selectedUser.first_name}</p>
        <ChevronIcon className={`${styles.organizationSelectSelectorArrow}
        ${expanded ? styles.expanded : undefined}`} />
      </div>
      <div className={`${styles.organizationSelectDropdown}
      ${expanded ? styles.expanded : styles.closed}`}>
        {props.memberships.map((membership) => (
          <div
          key={membership.owner.id}
          className={`${styles.organizationSelectOption}
          ${selectedUserId === membership.owner.id ? styles.hide : ''}`}
          onClick={() => onOrganizationChange(membership)}>
            <Avatar
              user={membership.owner}
              size="small"/>
            <p className={styles.organizationSelectName}>{membership.owner.first_name}</p>
          </div>
        ))}
        <div
        key={props.currentUser}
        className={`${styles.organizationSelectOption}
        ${selectedUserId === props.currentUser.id ? styles.hide : '' }`}
        onClick={() => onOrganizationChange(currentUserToMembership(props.currentUser))}>
          <Avatar
            user={props.currentUser}
            size="small" />
          <p className={styles.organizationSelectName}>
            {props.intl.formatMessage(locale.myAccount)}
          </p>
        </div>
      </div>
    </div>
  )
}

export default OrganizationSelect;
